import { Injectable, inject } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { ProfileState } from '@core/store/profile/profile.state';
import { Store } from '@ngxs/store';
import { format } from 'date-fns';

const TODAY = format(new Date(), 'yyyy/MM/dd');

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  private store = inject(Store);
  private cloudStorage = inject(AngularFireStorage);

  uploadFile(file: File, opts?: { isPrivate?: boolean; attachment?: boolean; path?: string }) {
    const visibility = opts?.isPrivate ? 'private' : 'public';
    const disposition = opts?.attachment ? 'attachment' : 'inline';

    const userId = this.store.selectSnapshot(ProfileState.profile)!.uid;
    // TODO: implement login required trow error
    const filename = this.generateUid() + '.' + file.name.split('.').pop();
    const path = `${visibility}/users/${userId}/${opts?.path || TODAY}/${filename}`;

    return this.cloudStorage.ref(path).put(file, {
      contentDisposition: `${disposition}; filename=${filename}`,
      customMetadata: { name: file.name, visibility },
    });
  }

  downloadFile(url: string) {
    this.cloudStorage
      .refFromURL(url)
      .getMetadata()
      .subscribe((metadata) => {
        const filename = metadata.name;
        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            const blobURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobURL;
            a.style.display = 'none';
            if (filename && filename.length) a.download = filename;
            document.body.appendChild(a);
            a.click();
          });
      });
  }

  /**
   * Genera un identificador único.
   * @param length Longitud del identificador único.
   * @returns {string} Identificador único.
   */
  private generateUid(length = 16): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let uid = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      uid += characters.charAt(randomIndex);
    }
    return uid;
  }
}
